import '../scss/blog-post-style.scss';
import PostPage from './pages/blog/post/index';

document.addEventListener('DOMContentLoaded', () => {
  PostPage.init();
});
